import { OrderItem, ReducedOrder } from "../generated/graphql";

export function displayPrice(price: number): string {
  if (isNaN(price)) return "0.00";
  const parts = price.toFixed(2).split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function getPriceFromString(priceString: string): number {
  const priceNumber = Number(priceString);
  if (isNaN(priceNumber)) {
    return 0;
  }
  return priceNumber;
}

export function getTotalPriceFromOrderItems(orderItems: OrderItem[]) {
  return orderItems.reduceRight((total, orderItem) => {
    const priceNumber = getPriceFromString(orderItem.unitPrice);
    return total + priceNumber * orderItem.quantity;
  }, 0);
}

export function getOrderCurrency(order: ReducedOrder): string {
  const firstItem = order.items[0];
  return firstItem != null ? firstItem.currency : "";
}

// NOTE(allen): only support HKD for now
const currencyPrefixMap: { [key: string]: string } = {
  HKD: "HK$",
};

export const getPriceWithCurrency = (currency: string, price: number) => {
  const prefix = currencyPrefixMap[currency] || "$";
  return `${prefix} ${displayPrice(price)}`;
};
